import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import useTracking from '../Tracking/useTracking';
import { mergeDeep, getOptimizedImageUrl } from '../../lib/utils.js';

const vWidth = window.innerWidth || document.documentElement.clientWidth;



const StyledSlider = styled(Slider)
`
    max-width: 1920px;
    margin: 0 auto;
    
    .slick-arrow {
        top: 50%;
        z-index: 9;
        width: 0px;
        height: 0px;
        position: absolute;
        border-style: solid;
        transform: translateY(-20px);
        cursor: pointer;
        outline: none;
        font-size: 0;
        line-height: 0;
        color: transparent;
        background: transparent;
    }

    .slick-prev {
        left: 0;
        border-width: 24px 24px 24px 0;
        border-color: ${p => `transparent ${p.arrowBgColor} transparent transparent` };
    }

    .slick-next {
        right: 0;
        border-width: 24px 0 24px 24px;
        border-color: ${p => `transparent transparent transparent ${p.arrowBgColor}` };
    }
`;

const BannerSliderWrapper = styled.div `
    position: relative;
    display: flex !important;
    justify-content: space-between;

    @media (max-width: 995px) {
        width: 100%;
        flex-direction: column;
        justify-content: center;
    }
`;

const BannerSliderTextWrapper = styled.div `
    width: 48%;
    height: 100%;
    color: ${p => p.textColor};
    text-align: center;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;

    @media (max-width: 995px) {
        position: static;
        width: 100%;
        justify-content: center;
        text-align: center;
        max-width: none;
        padding: 40px 35px;
        min-height: 0;
        order: 2;
    }

    @media (max-width: 700px) {
        padding: 30px 30px 40px;
    }
`;

const BannerSliderCallToAction = styled.a `
    text-decoration: none;
    transition: background .3s;
    padding: 15px 50px;
    color: ${p => p.callToActionColor};
    background: ${p => p.callToActionBgColor};
    text-transform: uppercase;
    font-size: 110%;
    font-weight: 700;
    letter-spacing: 2px;
    border: 0;
    position: relative;
    z-index: 1;
    text-align: center;
    margin-bottom: 12%;
    display: ${p => p.desktopHideCTA?'none':'block'};
    ${p=> p.desktopHideCTA?'cursor:pointer;':''}

    @media (max-width: 995px) {
        margin-bottom: 0;
        width: calc(100% - 50px);
        max-width: 550px;
        z-index: 1;
        margin-bottom: 30px;
        font-size: 3vw;
        padding: 20px 25px;
        letter-spacing: 2px;
        display:block;
    }

    @media (max-width: 700px) {
        font-size: 22px;
        padding: 10px 25px;
        font-weight: 600;
        position: static;
        transform: none;
        display: inline-block;
        margin: 0;
        width: 100%;
        display:block;
    }
`;

const BannerSliderImage = styled.img `
    display: block;
    width: 100%;
`;

const BannerSliderWithCTA = ({
    banners = [],
    arrowBgColor = '#fff',
    textColor = '#888',
    callToActionColor = '#000',
    callToActionBgColor = '#7e8fbb',
    buttonLink,
    buttonText = 'Start your trial',
    settings,
    imageQuality = '90',
    mobileBreakpoint = 700,
    desktopHideCTA = false
}) => {

    let defaultSettings = {
        infinite: true,
        speed: 2000,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        fade: true,
        adaptiveHeight: true,
        responsive: [{
            breakpoint: 995,
            settings: {
                arrows: false
            }
        }]
    };

    settings = mergeDeep(defaultSettings || {}, settings || {});


    // We don't want more slides then we have items
    if (settings.slidesToShow > banners.length) {
        settings.slidesToShow = banners.length;
        settings.slidesToScroll = banners.length;
    }

    const { trackAndRedirect } = useTracking();

    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        let payload = { component: 'BannerSliderWithCTA' };
        trackAndRedirect(payload, buttonLink);
    };

    const isMobile = vWidth <= mobileBreakpoint;

    return (
        <StyledSlider {...settings} arrowBgColor={arrowBgColor}>
            {banners.map((item,idx) => (
                <BannerSliderWrapper key={idx}>
                    <BannerSliderTextWrapper textColor={textColor} onClick={desktopHideCTA?handleClick:null}>
                        <BannerSliderCallToAction title="Join Adult Time Now" href="#" callToActionColor={callToActionColor} 
                        callToActionBgColor={callToActionBgColor} onClick={handleClick} desktopHideCTA={desktopHideCTA} >
                            {buttonText}
                        </BannerSliderCallToAction>
                    </BannerSliderTextWrapper>
                    <BannerSliderImage src={getOptimizedImageUrl(isMobile&&item.mobileImgSrc?item.mobileImgSrc:item.imgSrc, imageQuality)} alt={item.imageAlt} />

                </BannerSliderWrapper>
            ))}
        </StyledSlider>
    )
};

export default BannerSliderWithCTA;
